module.exports = __webpack_public_path__ + "img/error-v2.d5e2f2fc.png";